import { toRem, toRems } from '../../../../helpers/theme'
import { normalizeDimension } from '../../../../helpers/utils'

const config = {
    margin: 5,
    padding: [0, 0, 0, 10],
    small: {
        height: 40 // input element min height
    },
    normal: {
        height: 48 // input element min height
    },
    large: {
        height: 62 // input element min height
    }
}

const style = ({ theme, suffixWidth, size, error }) => {
    const getSuffixColor = () => {
        let suffixColor = 'currentColor'
        if (error) {
            suffixColor = theme.colors.form.error.text
        }
        return suffixColor
    }

    return {
        display: 'flex',
        alignItems: 'center',
        margin: toRems([config.margin, 0]),
        minHeight: toRem(config[size].height - config.margin * 2),
        padding: toRems(config.padding),
        fontSize: toRem(14),
        lineHeight: 1,
        color: getSuffixColor(),
        fontWeight: theme.typography.fontWeight.normal,
        ...(suffixWidth && {
            width: '100%',
            maxWidth: normalizeDimension(suffixWidth, true)
        }),
        [theme.breakpoints.up('md')]: {
            fontSize: toRem(16)
        }
    }
}

export default style
